import { ActionType } from 'typesafe-actions';
import * as actions from './actions';
import { OptionMenuActions } from './types';

export type OptionsMenuAction = ActionType<typeof actions>;

export interface MarkSchemeFile {
    title: string;
    contentItemId: number;
    extension: string;
}

export interface WorkflowSettingsState {
    isLocked: boolean;
    lockedBy: number;
}

export interface OptionsMenuState {
    readonly activeActionName: string;
    readonly isProcessing: boolean;
    readonly timesOfDownloadApiCalls: number;
    readonly isConfirmModalOpen: boolean;
    readonly isMenuOpen: boolean;
    readonly markSchemeFile: MarkSchemeFile;
}

export const initialState: OptionsMenuState = {
    activeActionName: '',
    isProcessing: false,
    timesOfDownloadApiCalls: 0,
    isConfirmModalOpen: false,
    isMenuOpen: false,
    markSchemeFile: null,
};

export const optionsMenuReducer = (state = initialState, action: OptionsMenuAction) => {
    switch (action.type) {
    case OptionMenuActions.CLOSE_OPTIONS_MENU:
        return {
            ...initialState,
            markSchemeFile: state.markSchemeFile,
        };
    case OptionMenuActions.API_CALL_IS_FINISHED:
    case OptionMenuActions.ON_FILE_IS_READY_FOR_DOWNLOAD:
    case OptionMenuActions.ON_FILE_IS_UPLOADED:
    case OptionMenuActions.ON_CANCEL_ACTION:
        return {
            ...state,
            activeActionName: '',
            isProcessing: false,
            timesOfDownloadApiCalls: 0,
            isConfirmModalOpen: false,
        };
    case OptionMenuActions.OPEN_OPTIONS_MENU:
        return {
            ...state,
            isMenuOpen: true,
        };
    case OptionMenuActions.ON_TOGGLE_CONFIRM_MODAL:
        return {
            ...state,
            activeActionName: action.payload,
            isConfirmModalOpen: !state.isConfirmModalOpen,
            isMenuOpen: false,
        };
    case OptionMenuActions.ON_MENU_ITEM_CLICK:
        return {
            ...state,
            activeActionName: action.payload,
            isProcessing: true,
            timesOfDownloadApiCalls: 0,
            isConfirmModalOpen: false,
        };
    case OptionMenuActions.CALL_DOWNLOAD_FILE_API:
        return {
            ...state,
            timesOfDownloadApiCalls: state.timesOfDownloadApiCalls + 1,
        };

    case OptionMenuActions.ON_MARK_SCHEME_FILE_UPLOADED:
        return {
            ...state,
            markSchemeFile: action.payload,
        };
    case OptionMenuActions.RESET_MARK_SCHEME_FILE_UPLOADED:
        return {
            ...state,
            markSchemeFile: null,
        };
    default:
        return state;
    }
};
